import React from "react";
import Dialog from "@material-ui/core/Dialog";
import Translated from "../../components/Translated/Translated";

function DialogStatus(props) {
	const [open, setOpen] = React.useState(false);

	async function handleClose(e) {
		e.stopPropagation();
		setOpen(false);
	}

	async function handleClickOpen(e) {
		e.stopPropagation();
		setOpen(true);
	}

	function formBody() {
		return (
			<div class="quote-dialog-body">
				<div class="fquote-dialog-info">
					<div>{props.message}</div>
				</div>
			</div>
		);
    }
    
	return (
		<td class="dialog-status-wrapper" onClick={handleClickOpen}>
			<div class="dialog-status">{props.label}</div>
			<Dialog open={open} onClose={handleClose}>
				<div class="quote-dialog">
					<div class="quote-dialog-title"><Translated section="Misc" label="archival_reason_dialog_title" /></div>
					{formBody()}
					<div class="quote-dialog-footer">
						<button class="quote-dialog-button" onClick={handleClose}><Translated section="Misc" label="close_btn" /></button>
					</div>
				</div>
			</Dialog>
		</td>
	);
}

export default DialogStatus;
